import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import DialogPin from "./DialogPin";
import { Dialog } from "primereact/dialog";
import { handlePostRequest } from "../../services/PostTemplate";

const GeneratePin = () => {
    const [displayModal, setDisplayModal] = useState(false);
    const [loadingSecurityPin, setloadingSecurityPin] = useState(true);
    const [loadingGenPin, setloadingGenPin] = useState(false);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [optCode, setoptCode] = useState({ firstDigit: "", secondDigit: "", thirdDigit: "", fourthDigit: "" });

    useEffect(() => {
        const focusfield = document.querySelector(`#inputfield1`);
        focusfield.focus();
    }, []);

    const onHide = () => {
        setDisplayModal(false);
    };

    const handleGeneratePin = async () => {
        setloadingGenPin(true);
        const res = await handlePostRequest({}, "zbizgateway/nonFin/checkOtp");
        if (res?.data?.expire === "Y") {
            setDisplayModal(true);
            setloadingGenPin(false);
        } else {
            const focusfield = document.querySelector(`#inputfield1`);
            focusfield.focus();
            setMinutes(1);
            setTimeout(() => {
                setloadingGenPin(false);
            }, 60000);
        }
    };

    const clearForm = () => {
        setoptCode({ firstDigit: "", secondDigit: "", thirdDigit: "", fourthDigit: "" });
    };

    useEffect(() => {
        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval);
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000);
        return () => {
            clearInterval(myInterval);
        };
    });

    const sendOtpCode = async (fourthDigit) => {
        const res = await handlePostRequest({ securityPin: optCode?.firstDigit + optCode?.secondDigit + optCode?.thirdDigit + fourthDigit }, "zbizgateway/nonFin/verifySecurityOtpPin");
        if (res?.data === "Y") {
            setloadingSecurityPin(false);
        }
        clearForm();
    };

    return (
        <>
            <Dialog visible={displayModal} style={{ width: "50vw" }} onHide={() => setDisplayModal(false)}>
                <DialogPin onHide={onHide} clearForm={clearForm} loadingSecurityPin={loadingSecurityPin} setloadingSecurityPin={setloadingSecurityPin} />
            </Dialog>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Generate Pin</h1>
                </div>
                <div className="p-fluid p-formgrid p-grid p-mt-3">
                    <p className="Generate__Para">We've sent a 4-digit Generate Pin</p>
                </div>
                <div className="p-fluid p-formgrid p-grid">
                    <p className="Generate__Para">to your email address.</p>
                </div>
                <div className="p-fluid p-formgrid p-grid p-mt-3">
                    <p className="Generate__Para">Enter Email the 4-digits OTP:</p>
                </div>

                <div className="p-fluid p-formgrid p-grid p-mt-3">
                    <div className="Generate__Div">
                        <input
                            type="text"
                            value={optCode?.firstDigit}
                            onChange={(e) => {
                                setoptCode({ ...optCode, firstDigit: e.target.value });
                                if (e.target.value !== "") {
                                    const focusfield = document.querySelector(`#inputfield2`);
                                    focusfield.focus();
                                }
                            }}
                            className="Generate__Input"
                            maxLength="1"
                            id="inputfield1"
                        />
                        <input
                            type="text"
                            value={optCode?.secondDigit}
                            className="Generate__Input"
                            maxLength="1"
                            onChange={(e) => {
                                setoptCode({ ...optCode, secondDigit: e.target.value });
                                if (e.target.value !== "") {
                                    const focusfield = document.querySelector(`#inputfield3`);
                                    focusfield.focus();
                                }
                            }}
                            id="inputfield2"
                        />
                        <input
                            type="text"
                            className="Generate__Input"
                            value={optCode?.thirdDigit}
                            maxLength="1"
                            onChange={(e) => {
                                setoptCode({ ...optCode, thirdDigit: e.target.value });
                                if (e.target.value !== "") {
                                    const focusfield = document.querySelector(`#inputfield4`);
                                    focusfield.focus();
                                }
                            }}
                            id="inputfield3"
                        />
                        <input
                            type="text"
                            className="Generate__Input"
                            value={optCode?.fourthDigit}
                            maxLength="1"
                            onChange={(e) => {
                                setoptCode({ ...optCode, fourthDigit: e.target.value });
                                if (e.target.value !== "") {
                                    sendOtpCode(e.target.value);
                                }
                            }}
                            id="inputfield4"
                        />
                    </div>
                </div>

                <div className="GenerateDown__Btn">
                    <Button disabled={loadingGenPin} label="Generate Pin" className="Btn__Dark" onClick={() => handleGeneratePin()} />
                    <div>{minutes === 0 && seconds === 0 ? null : <h4>{"Wait " + minutes + ":" + seconds + " to generate a new pin again"}</h4>}</div>
                </div>

                <div align="center" className="p-button-rounded p-button-success">
                    <Button disabled={loadingSecurityPin} label="Generate Security Pin" className="p-button-rounded p-button-warning" onClick={() => setDisplayModal(true)} />
                </div>

                <div className="p-fluid p-formgrid p-grid p-mt-3 p-mb-6">
                    <p className="Generate__Para">Resend Code after</p>
                </div>
            </div>
        </>
    );
};

export default GeneratePin;
